import { useState } from "react";
import { Link } from "react-router-dom";
import type { Product } from "@/mocks/products";
import { formatBRL } from "@/utils/format";
import { discountPercent } from "@/utils/collections";

// Cartão de produto da página inicial: etiqueta de desconto real (só com preço "de" da
// Nuvemshop), coração, preços, parcelas e botão de compra.
export default function LpProductCard({ product, onAdd, rank }: { product: Product; onAdd: (product: Product) => void; rank?: number }) {
  const [favorite, setFavorite] = useState(false);
  const off = discountPercent(product);
  const soldOut = product.inStock === false;
  return (
    <article className="lp-card" data-lp-card>
      <div className="lp-card-media">
        <Link to={`/produto/${product.id}`} aria-label={product.name} className="lp-card-photo">
          <img src={product.image} alt={product.name} loading="lazy" decoding="async" />
        </Link>
        {rank && <span className="lp-rank">{rank}º</span>}
        {off > 0 && <span className="lp-badge">-{off}%</span>}
        <button
          type="button"
          className={`lp-heart ${favorite ? "on" : ""}`}
          aria-label={favorite ? "Remover dos favoritos" : "Adicionar aos favoritos"}
          aria-pressed={favorite}
          onClick={() => setFavorite((prev) => !prev)}
        >
          <i className={favorite ? "ri-heart-fill" : "ri-heart-line"} aria-hidden="true"></i>
        </button>
      </div>
      <div className="lp-card-body">
        <h3><Link to={`/produto/${product.id}`}>{product.name}</Link></h3>
        {off > 0 && product.compareAtPrice && <s className="lp-old">{formatBRL(product.compareAtPrice)}</s>}
        <strong className="lp-price">{formatBRL(product.price)}</strong>
        <small className="lp-installments">em até {product.installments}x de {formatBRL(product.installmentValue)}</small>
        <button type="button" className="lp-buy" disabled={soldOut} onClick={() => onAdd(product)}>
          {soldOut ? "INDISPONÍVEL" : "COMPRAR"}
        </button>
      </div>
    </article>
  );
}
